import { useParams } from 'react-router-dom'
import { Ticket } from './Ticket'
import { useGlobalState } from '../../hooks/useGlobalState'

export const Tickets = () => {
   const { type } = useParams()
   const { tickets } = useGlobalState()

   return (
      <div className='tickets'>
         <h1>- Most Popular -</h1>
         <main>
            {
               tickets.find(t => t.name === type).tickets.map((ticket, index) =>
                  <Ticket key={index} ticket={ticket} />
               )
            }
         </main>
      </div>
   )
}